// ** React Imports
import { useState } from 'react'

// ** Third Party Imports
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

// ** Schema & Variables Imports
import { defaultValues } from './defaultValues'
import { schema } from './schema'

// ** Action Imports
import { useSendEmailForCustomPlanMutation } from '../api/subscription'

interface IProps {
	initialOpen?: boolean
}

export const useSubscription = ({ initialOpen = false }: IProps) => {
	// ** State
	const [isOpen, setIsOpen] = useState(initialOpen)

	const {
		control,
		handleSubmit,
		trigger,
		reset,
		formState: { errors }
	} = useForm<any>({
		defaultValues,
		mode: 'onChange',
		resolver: yupResolver(schema)
	})

	const [sendEmail, { isSuccess, isLoading }] =
		useSendEmailForCustomPlanMutation()

	const onSubmit = (formData: any) => {
		sendEmail({ ...formData })
	}

	return {
		isOpen,
		setIsOpen,
		errors,
		control,
		onSubmit,
		handleSubmit,
		reset,
		trigger,
		isLoading,
		isSuccess
	}
}
